import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
} from '../'
import Styles from './ResolutionText.css'

@CSSModules(Styles, {allowMultiple: true})
export default class MicrosoftResolutionText extends Component {
  render() {
    return (
      <div>
        <p>
          <Link
            to='https://www.asyousow.org/resolutions/2022/06/14-microsoft-report-on-aligning-retirement-plan-options-with-company-climate-goals'
            title={'Microsoft shareholder resolution'}
            xstrong
          >
            More resolution details<LinkIcon/>
          </Link>
        </p>
        <blockquote styleName='company-resolution-blockquote'>
          <p>
            <b>WHEREAS:</b> Shareholders applaud Microsoft for adopting ambitious climate goals, including its commitment to become carbon negative by 2030, reduce Scope 1 and 2 emissions to near zero by the middle of the decade through energy efficiency work, and reach 100 percent renewable energy by 2025.
          </p>
          <p>
            While our company has made significant efforts to address climate change across its operations, data from Department of Labor filings showing company retirement plan options and invested amounts suggest to investors that Microsoft has failed to address the material risks of climate change in its 401(k) Plan in alignment with the duty to select retirement plan investment options in the best interests of plan participants and beneficiaries.
          </p>
          <p>
            Microsoft uses BlackRock LifePath funds as its 401(k) Plan’s default retirement options, resulting in the vast majority of the $38 billion employee retirement dollars of its 401(k) Plan, as of December 31, 2020,  invested in funds that hold companies that create substantial climate risk. A recent scorecard, produced by investor representative As You Sow, shows that the Microsoft 401(k) default option is rated Poor due to significant investments in fossil fuel companies and companies that cause deforestation risk.
          </p>
          <p>
            While Microsoft allows employees to use a “self-directed” investment option to choose other funds, only 6 percent of employee retirement funds are invested outside the Plan.
          </p>
          <p>
            In polls with investors broadly, more than 70 percent say that they would like to invest sustainably and, specifically, not in oil, coal, and deforestation. In the increasingly competitive employee retention and recruitment landscape, failing to provide climate-safe retirement plan options may also make it more difficult for Microsoft to attract and retain top talent.
          </p>
          <p>
            Given the threat that climate change poses to workers’ life savings, Microsoft should demonstrate that it is safeguarding employee financial security over time by mitigating climate change-related financial and economic risks as part of a prudently constructed lineup of funds.
          </p>
          <p>
            Failing to satisfy this basic duty could be a liability for the Company, creating reputational risk and making it more difficult to retain employees increasingly concerned about catastrophic climate impacts.
          </p>
          <p>
            <b>BE IT RESOLVED:</b> Shareholders request the board provide a report assessing how the Company’s 401(k) retirement funds manage the growing systemic risk to the economy created by investing retirement plan funds in companies contributing significantly to climate change.
          </p>
          <p>
            <b>SUPPORTING STATEMENT:</b> Such analysis should include, at Board discretion, whether  plan decisionmakers have considered:
          </p>
          <ol>
            <li>
              Climate risk in portfolio offerings;
            </li>
            <li>
              Whether inclusion of high carbon companies in plans contributes to greater economic volatility over time, and the impact of such volatility on retirement fund performance over time;
            </li>
            <li>
              Whether inclusion of high carbon companies contributing to climate change puts younger plan participants’ retirement funds at greater economic risk than plan participants nearer retirement age.
            </li>
          </ol>
        </blockquote>
      </div>
    )
  }
}